export default __webpack_public_path__ + "fonts/LAUNCHPAD_LOGO_wht_NoTagline2.svg";